import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faYoutube,
  faWhatsapp,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { 
  faEnvelope, 
  faPhone, 
  faClock, 
  faMapMarkerAlt,
  faChevronRight,
  faHeart 
} from "@fortawesome/free-solid-svg-icons";
import "../Styles/Footer.css";

function Footer() {
  const phoneNumber = "9647744052020";
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [expandedSections, setExpandedSections] = useState({
    products: false,
    quickLinks: false,
    contact: false
  });

  const handleLinkClick = (path) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const productLinks = [
    { path: "/HAIRREMOVAL", label: "Hair Removal" },
    { path: "/aiskin", label: "AI Skin Analyzer" },
    { path: "/co2", label: "CO2 Laser" },
    { path: "/revive", label: "IPL Revive" },
    { path: "/thermilif", label: "Thermilif HIFU" },
    { path: "/rf", label: "ThermiQ RF" },
    { path: "/pictron11", label: "Pictron11" },
   
  ];

  const quickLinks = [
  { path: "/cicalfate", label: "Cicalfate+" },
    { path: "/about-us", label: "About Us" },
    { path: "/contact-us", label: "Contact Us" },
  ];

  return (
    <footer className="footer">
      {/* Wave Decoration */}
      <div className="footer-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="currentColor" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
        </svg>
      </div>

      {/* Main Footer */}
      <div className="footer-main">
        <Container>
          <Row className="g-4">
            {/* About Section - Always visible */}
            <Col lg={4} md={12} className="order-lg-1 order-1">
              <div className="footer-widget about-widget">
                <div className="widget-header">
                  <h4 className="footer-title">
                    <span className="title-icon">✦</span>
                    Epilyum
                  </h4>
                </div>
                <div className="widget-content">
                  <p className="footer-description">
                    Epilyum is an innovative company specializing in aesthetic and medical technologies, 
                    offering advanced devices for Dermatologists. With a focus on science, safety, and 
                    performance, Epilyum provides reliable solutions that combine cutting-edge technology 
                    with proven clinical results.
                  </p>
                  <div className="footer-badges">
                    <span className="badge">Medical Grade</span>
                    <span className="badge">CE Certified</span>
                    <span className="badge">ISO 13485</span>
                  </div>
                </div>
              </div>
            </Col>

            {/* Products Section - Collapsible on mobile */}
            <Col lg={2} md={4} className="order-lg-2 order-2">
              <div className="footer-widget">
                <div 
                  className="widget-header mobile-toggle" 
                  onClick={() => toggleSection('products')}
                >
                  <h4 className="footer-title">
                    <span className="title-icon">⚡</span>
                    Devices
                  </h4>
                  <span className="toggle-icon">
                    {expandedSections.products ? '−' : '+'}
                  </span>
                </div>
                <div className={`widget-content ${expandedSections.products ? 'expanded' : ''}`}>
                  <ul className="footer-links">
                    {productLinks.map((link) => (
                      <li key={link.path}>
                        <a 
                          href="#!" 
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick(link.path);
                          }}
                        >
                          <FontAwesomeIcon icon={faChevronRight} className="link-icon" />
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Col>

            {/* Quick Links - Collapsible on mobile */}
            <Col lg={2} md={4} className="order-lg-3 order-3">
              <div className="footer-widget">
                <div 
                  className="widget-header mobile-toggle" 
                  onClick={() => toggleSection('quickLinks')}
                >
                  <h4 className="footer-title">
                    <span className="title-icon">🔗</span>
                    Quick Links
                  </h4>
                  <span className="toggle-icon">
                    {expandedSections.quickLinks ? '−' : '+'}
                  </span>
                </div>
                <div className={`widget-content ${expandedSections.quickLinks ? 'expanded' : ''}`}>
                  <ul className="footer-links">
                    {quickLinks.map((link) => (
                      <li key={link.path}>
                        <a 
                          href="#!" 
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick(link.path);
                          }}
                        >
                          <FontAwesomeIcon icon={faChevronRight} className="link-icon" />
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Col>

            {/* Contact & Social - Collapsible on mobile */}
            <Col lg={4} md={4} className="order-lg-4 order-4">
              <div className="footer-widget">
                <div 
                  className="widget-header mobile-toggle" 
                  onClick={() => toggleSection('contact')}
                >
                  <h4 className="footer-title">
                    <span className="title-icon">📞</span>
                    Contact
                  </h4>
                  <span className="toggle-icon">
                    {expandedSections.contact ? '−' : '+'}
                  </span>
                </div>
                <div className={`widget-content ${expandedSections.contact ? 'expanded' : ''}`}>
                  {/* Contact Info */}
                  <ul className="footer-contact">
                    <li>
                      <div className="contact-icon">
                        <FontAwesomeIcon icon={faPhone} />
                      </div>
                      <div className="contact-info">
                        <span className="contact-label">Phone</span>
                        <a href={`tel:${phoneNumber}`}>+964 774 405 2020</a>
                      </div>
                    </li>
                    <li>
                      <div className="contact-icon">
                        <FontAwesomeIcon icon={faEnvelope} />
                      </div>
                      <div className="contact-info">
                        <span className="contact-label">Email</span>
                        <a href="mailto:info@epilyum.com">info@epilyum.com</a>
                      </div>
                    </li>
                    <li>
                  
                    
                    </li>
                  </ul>

                  {/* Social Media */}
                  <div className="social-section">
                    <p className="social-text">Follow us for updates</p>
                    <div className="social-links">
                      <a 
                        href="https://www.facebook.com/profile.php?id=100094224227961&mibextid=LQQJ4d" 
                        className="social-link facebook"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                      >
                        <FontAwesomeIcon icon={faFacebookF} />
                      </a>
                      <a 
                        href="https://www.instagram.com/epilyum.official/?hl=en" 
                        className="social-link instagram"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                      >
                        <FontAwesomeIcon icon={faInstagram} />
                      </a>
                      <a 
                        href="https://www.youtube.com/@Epilyumofficial" 
                        className="social-link youtube"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="YouTube"
                      >
                        <FontAwesomeIcon icon={faYoutube} />
                      </a>
                      <a 
                        href={`https://wa.me/${phoneNumber}`} 
                        className="social-link whatsapp"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="WhatsApp"
                      >
                        <FontAwesomeIcon icon={faWhatsapp} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={6} className="text-center text-md-start">
              <p className="copyright">
                © {currentYear} Epilyum. All rights reserved.
              </p>
            </Col>
            <Col xs={12} md={6} className="text-center text-md-end">
             
            </Col>
          </Row>
        </Container>
      </div>

      {/* Back to Top Button */}
      <button 
        className="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Back to top"
      >
        ↑
      </button>
    </footer>
  );
}

export default Footer;